import React, { useMemo, useState } from "react";
import { withTranslation } from "react-i18next";

import "./OperatorPlanQuotaBar.css";

function PlanOperatorSelectionModal({
  operators,
  limit,
  onClose,
  onSave,
  t,
  title,
  description,
}) {
  const initialSelected = useMemo(
    () =>
      operators.filter((operator) => operator.plan_included).map((operator) => operator.id),
    [operators]
  );
  const [selectedIds, setSelectedIds] = useState(initialSelected);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  function toggleOperator(operatorId) {
    setError("");
    setSelectedIds((current) => {
      if (current.includes(operatorId)) {
        return current.filter((id) => id !== operatorId);
      }
      if (current.length >= limit) {
        setError(
          t("Selecione no máximo {{limit}} operador(es) com licença do app.", {
            limit,
          })
        );
        return current;
      }
      return [...current, operatorId];
    });
  }

  async function handleSave() {
    if (selectedIds.length > limit) {
      setError(
        t("Selecione no máximo {{limit}} operador(es) com licença do app.", {
          limit,
        })
      );
      return;
    }
    setSaving(true);
    setError("");
    try {
      await onSave(selectedIds);
      onClose();
    } catch (saveError) {
      const message =
        saveError.response &&
        saveError.response.data &&
        (saveError.response.data.detail || saveError.response.data.plan_included);
        setError(message || t("Falha ao salvar a seleção de licenças do app."));
    } finally {
      setSaving(false);
    }
  }

  return (
    <div className="plan-operator-selection-backdrop" role="presentation">
      <div className="plan-operator-selection-modal" role="dialog" aria-modal="true">
        <div className="plan-operator-selection-modal__header">
          <h3>{title || t("Licenças do aplicativo")}</h3>
          <button type="button" className="close" onClick={onClose} aria-label={t("Fechar")}>
            ×
          </button>
        </div>
        <div className="plan-operator-selection-modal__body">
          <p>
            {description ||
              t(
                "Selecione os operadores que poderão usar a licença do aplicativo. Os demais continuam cadastrados, mas sem envio pelo app."
              )}
          </p>
          <p className="text-muted">
            {t("{{selected}} de {{limit}} selecionado(s)", {
              selected: selectedIds.length,
              limit,
            })}
          </p>
          <ul className="plan-operator-selection-list">
            {operators.map((operator) => (
              <li key={operator.id}>
                <label>
                  <input
                    type="checkbox"
                    checked={selectedIds.includes(operator.id)}
                    onChange={() => toggleOperator(operator.id)}
                  />{" "}
                  <strong>{operator.nome}</strong>
                  {operator.ident ? ` — ${operator.ident}` : ""}
                  {operator.plan_included ? (
                    <span className="plan-operator-selection-list__badge">
                      {t("Licença")}
                    </span>
                  ) : null}
                </label>
              </li>
            ))}
          </ul>
          {error ? <div className="alert alert-danger">{error}</div> : null}
        </div>
        <div className="plan-operator-selection-modal__footer">
          <button type="button" className="btn btn-default" onClick={onClose}>
            {t("Cancelar")}
          </button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={handleSave}
            disabled={saving}
          >
            {saving ? t("Salvando...") : t("Salvar seleção")}
          </button>
        </div>
      </div>
    </div>
  );
}

export default withTranslation()(PlanOperatorSelectionModal);
